__webpack_require__.p = "/mi-assets/mi-static/mi-cobrand-renderer/phx-rel-R24.11.2-5NOV2024549PMIST/_next/";